<script setup lang="ts">
</script>

<template>
  <div
    tabindex="0"
    class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-py-3 tw-cursor-pointer tw-select-none
           tw-rounded-md tw-outline-none
           focus-visible:tw-ring-2 focus-visible:tw-ring-primary-light dark:focus-visible:tw-ring-primary-dark">
    <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-3">
      <span class="tw-flex tw-size-5 tw-shrink-0 tw-items-center tw-justify-center">
        <slot name="icon"/>
      </span>
      <div class="tw-min-w-fit">
        <div class="tw-text-sm tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark">
          <slot name="label"/>
        </div>
        <div v-if="$slots.helper" class="tw-text-xs tw-text-namaGray dark:tw-text-gray-400">
          <slot name="helper"/>
        </div>
      </div>
    </div>
    <div class="tw-shrink-0">
      <slot name="control"/>
    </div>
  </div>
</template>
